import React, { FC, useEffect } from 'react';

interface HeaderProps {
    onRender: (render: boolean) => void;
}

const Header: FC<HeaderProps> = ({ onRender }: HeaderProps) => {
    useEffect(() => {
        /**
         * TODO: gnb, footer 먼저 생성 된 후 rendring 될 수 있도록 Observer 로직 추가
         */
        const observer = new MutationObserver(() => {
            const target = document.getElementById('serviceHeader');
            if (target !== null) {
                onRender(true);
                observer.disconnect(); // 더 이상 감지할 필요 없으므로 해제
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <div id="soop-gnb" />
        </>
    );
};

export default Header;
